import styled from 'styled-components'

export const SecondaryCategoryRowStyled = styled.button<{
  $isActive: boolean
}>`
  display: block;
  width: 100%;
  padding: ${(props) => props.theme.typography.pxToRem(12)}
    ${(props) => props.theme.typography.pxToRem(16)};
  border: none;
  border-bottom: 1px solid
    ${(props) => props.theme.colors.content.secondaryBorder};
  text-align: left;
  /* An unbroken name wraps inside the row; "anywhere" (unlike "break-word")
     also keeps it from widening the pane */
  overflow-wrap: anywhere;
  cursor: pointer;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: ${(props) =>
    props.$isActive
      ? props.theme.fontWeights.semibold
      : props.theme.fontWeights.normal};
  background-color: ${(props) =>
    props.$isActive ? props.theme.colors.selected : props.theme.colors.white};
  color: ${(props) => props.theme.colors.text.primary};

  &:hover {
    background-color: ${(props) =>
      props.$isActive
        ? props.theme.colors.selected
        : props.theme.colors.form.select.optionBackgroundHover};
  }
`
